var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpicy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM6.075 19.575C5.85 19.65 5.625 19.5 5.475 19.35C5.25 19.125 5.325 18.75 5.625 18.525C7.575 17.025 9.15 15.3 10.425 13.2C11.475 11.4 12.225 9.6 12.825 7.95C13.275 8.1 13.8 8.25 14.4 8.25C14.4 8.7 14.475 9.45 14.775 10.05L14.925 10.35L15.225 10.275C15.9 10.2 16.575 9.825 16.95 9.525C17.325 10.05 17.775 10.425 18.15 10.65C15.375 17.475 8.25 19.2 6.075 19.575ZM18.525 9.825C18.15 9.525 17.7 9.15 17.55 8.7L17.25 8.025L16.8 8.55C16.8 8.55 16.2 9.15 15.45 9.375C15.225 8.625 15.3 7.8 15.3 7.8L15.45 7.125L14.775 7.275C14.25 7.425 13.65 7.275 13.2 7.125C13.95 6.075 15.3 5.625 16.575 6L17.55 4.35L18.3 4.8L17.325 6.375C17.7 6.675 18 7.05 18.225 7.5C18.675 8.25 18.75 9.075 18.525 9.825Z",
    fill: "#EA5514"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicy);
export default __webpack_public_path__ + "static/media/spicy.514f34e7.svg";
export { ForwardRef as ReactComponent };